/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTexture } from "@react-three/drei";

// import modelPath from "./models/heat/gear.glb";
// import modelPath from "./models/heat/human.glb";
import { degToRad } from "three/src/math/MathUtils";

// import colorText from "./models/heat/worn-metal4-bl/worn_metal4_albedo.png";
// import occlusionText from "./models/heat/worn-metal4-bl/worn_metal4_ao.png";
// import metallicText from "./models/heat/worn-metal4-bl/worn_metal4_Metallic.png";
// import normalText from "./models/heat/worn-metal4-bl/worn_metal4_Normal-ogl.png";
// import roughnessText from "./models/heat/worn-metal4-bl/worn_metal4_Roughness.png";
import { Color, Euler, Mesh, Object3D, RepeatWrapping, Vector2, Vector3, PlaneGeometry, FloatType, HalfFloatType } from "three";

import fragmentSimulation from "./shader/fragmentsimulation.glsl";
import fragmentReplacement from "./shader/fragmentreplacement.glsl";
import vertexReplacement from "./shader/vertexreplacement.glsl";

import { GPUComputationRenderer } from "three/examples/jsm/misc/GPUComputationRenderer.js";
import { useFrame, useThree } from "@react-three/fiber";
import { MeshBasicMaterial } from "three";
import { MeshStandardMaterial } from "three";
import { MeshNormalMaterial } from "three";
import { BufferAttribute } from "three";

import { useEbbnenContext } from "@solidwhite/ebbnen";
import { useMultiuserContext, useSynchronizedState } from "@solidwhite/multiuser";
import { throttle } from "lodash-es";

import { useSpring } from "@react-spring/three";

const targetPoint = new Vector3(99999, 99999, 99999);

const WIDTH = 128;
const BOUNDS = 1,
  BOUNDS_HALF = BOUNDS / 2;

const InductionFloor = ({ ...props }) => {
  const { spectating, presenting, connected } = useMultiuserContext();

  const [floorGlowPosition, setFloorGlowPosition] = useSynchronizedState("floorglow", [99999, 99999, 99999]);

  const group = useRef();

  const { gl, scene, raycaster, camera, mouse } = useThree();

  const mesh = useRef();

  const shaderRef = useRef();
  const [refFound, setrefFound] = useState(false);

  const { currentLayer } = useEbbnenContext();

  const active = useMemo(() => {
    return currentLayer < 4;
  }, [currentLayer]);

  const fillPositions = (texture) => {
    let array = mesh.current.geometry.attributes.position.array;

    let dtArray = texture.image.data;

    for (let index = 0; index < array.length; index += 3) {
      let offset = (index / 3) * 4;
      var pos = new Vector3(array[index], array[index + 1], array[index + 2]);
      pos.applyMatrix4(group.current.matrixWorld);

      dtArray[offset] = pos.x;
      dtArray[1 + offset] = pos.y;
      dtArray[2 + offset] = pos.z;
      dtArray[3 + offset] = 0;
    }
  };

  const handelBeforeCompile = (shader) => {
    shader.uniforms.positionTexture = { value: null };
    shaderRef.current = shader;

    shader.vertexShader =
      `
    uniform sampler2D positionTexture;
    attribute vec2 reference;
    varying float displacement;
    varying vec3 vPos;
    ` + shader.vertexShader;

    shader.fragmentShader =
      `
    varying float displacement;
    varying vec3 vPos;
    ` + shader.fragmentShader;

    shader.vertexShader = shader.vertexShader.replace(`#include <fog_vertex>`, vertexReplacement);

    shader.fragmentShader = shader.fragmentShader.replace(`#include <dithering_fragment>`, fragmentReplacement);
  };

  const [gpuCompute, dtPosition, positionVariable, imperativeMesh] = useMemo(() => {
    // console.log(mesh.current);
    // if (!mesh.current) return [];
    var geo = new PlaneGeometry(40, 40, WIDTH - 1, WIDTH - 1);
    var mat = new MeshBasicMaterial({
      // metalness: 0.9,
      // roughness: 0.9,
      color: new Color("#333").convertSRGBToLinear(),
      opacity: 1,
      transparent: true,
      toneMapped: true,
    });
    mat.onBeforeCompile = handelBeforeCompile;

    var mesh = new Mesh(geo, mat);

    var group = new Object3D();
    group.position.set(0, -0.1, 0);
    group.rotation.set(-Math.PI / 2, 0, 0);
    group.updateMatrixWorld();

    mesh.position.y = -0.1;

    mesh.renderOrder = -11;

    group.add(mesh);

    var gpuCompute = new GPUComputationRenderer(WIDTH, WIDTH, gl);

    gpuCompute.setDataType(FloatType);

    var dtPosition = gpuCompute.createTexture();

    // fillPositions(dtPosition);

    let array = mesh.geometry.attributes.position.array;

    let dtArray = dtPosition.image.data;

    for (let index = 0; index < array.length; index += 3) {
      let offset = (index / 3) * 4;
      var pos = new Vector3(array[index], array[index + 1], array[index + 2]);

      pos.applyMatrix4(group.matrixWorld);

      dtArray[offset] = pos.x;
      dtArray[1 + offset] = pos.y;
      dtArray[2 + offset] = pos.z;
      dtArray[3 + offset] = 0;
    }

    var positionVariable = gpuCompute.addVariable("texturePosition", fragmentSimulation, dtPosition);

    gpuCompute.setVariableDependencies(positionVariable, [positionVariable]);

    positionVariable.wrapS = RepeatWrapping;
    positionVariable.wrapT = RepeatWrapping;

    positionVariable.material.uniforms["time"] = { value: 0 };
    positionVariable.material.uniforms["mouse"] = {
      value: targetPoint,
    };

    positionVariable.material.uniforms["mouseDamping"] = { value: 30.3 };

    const error = gpuCompute.init();

    if (error !== null) {
      console.error(error);
    }

    let reference = new Float32Array(WIDTH * WIDTH * 2);

    for (let i = 0; i < WIDTH * WIDTH; i++) {
      let x = (i % WIDTH) / WIDTH;
      let y = ~~(i / WIDTH) / WIDTH;
      reference.set([x, y], i * 2);
    }

    mesh.geometry.setAttribute("reference", new BufferAttribute(reference, 2));

    return [gpuCompute, dtPosition, positionVariable, group];
  }, []);

  // useEffect(() => {
  //   if (mesh.current) {
  //     setrefFound(true);
  //     let reference = new Float32Array(WIDTH * WIDTH * 2);

  //     for (let i = 0; i < WIDTH * WIDTH; i++) {
  //       let x = (i % WIDTH) / WIDTH;
  //       let y = ~~(i / WIDTH) / WIDTH;
  //       reference.set([x, y], i * 2);
  //     }

  //     mesh.current.geometry.setAttribute(
  //       "reference",
  //       new BufferAttribute(reference, 2)
  //     );
  //   }
  // }, [mesh.current]);

  const throttledSet = useMemo(() => {
    return throttle((value) => {
      setFloorGlowPosition(value);
    }, 33);
  }, []);

  const [spring, api] = useSpring(() => ({
    position: [0, 0, 0],
    onChange: ({ value }) => {
      targetPoint.fromArray(value.position);
    },
    config: {
      duration: 33,
      tension: 280,
      friction: 30,
    },
  }));

  useEffect(() => {
    if (spectating) {
      api.start({ position: floorGlowPosition });
    }
  }, [floorGlowPosition]);

  useFrame(({ clock }) => {
    if (!connected || presenting) {
      raycaster.setFromCamera(mouse, camera);

      const intersects = raycaster.intersectObjects(scene.children);

      if (intersects.length > 0 && active) {
        for (let i = 0; i < intersects.length; i++) {
          targetPoint.copy(intersects[i].point);
          targetPoint.y = 0;
        }
      } else if (positionVariable != undefined) {
        targetPoint.set(999999, 999999, 999999);
      }

      if (presenting) throttledSet(targetPoint.toArray());
    }
    positionVariable.material.uniforms.mouse.value = targetPoint;

    if (shaderRef.current && gpuCompute) {
      shaderRef.current.uniforms.positionTexture.value = gpuCompute.getCurrentRenderTarget(positionVariable).texture;

      gpuCompute.compute();
    }
  });

  useLayoutEffect(() => {
    scene.add(imperativeMesh);
    return () => {
      scene.remove(imperativeMesh);
      imperativeMesh.children[0].material.dispose();
      imperativeMesh.children[0].geometry.dispose();
    };
  }, []);

  return null;

  return (
    <group
      ref={group}
      {...props}
      // dispose={null}
      rotation={[-Math.PI / 2, 0, 0]}
      position={[8, -0.1, 0]}
    >
      <mesh position={[0, -0.1, 0]} ref={mesh} renderOrder={-11}>
        <planeGeometry args={[40, 40, 128, 128]} />
        <meshStandardMaterial
          metalness={0.9}
          roughness={0.4}
          normalScale={0.25}
          color="#333"
          onBeforeCompile={handelBeforeCompile}
          opacity={1}
          transparent
          // toneMapped={false}
          // vertexColors={true}
        />
      </mesh>
    </group>
  );
};

export default InductionFloor;
